import React, { useEffect, useRef, useState } from "react";
import {
    makeStyles,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    InputAdornment
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { validNationalId } from "../../method/validNarionalId/index";
import { getCaptcha } from "../../../redux/captchaPouyan/getcaptcha";
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { base64File } from "../../method/fineBase64file/finebase64file";
import { convertPersianToEnglishDigits } from "../../method/converter/converterText";
import { notificationAlertErrorApi } from "../../method/notificationAlertErrorApi/notificationAlertErrorApi";
import { apiCreateUserIPORequest } from "../../../redux/ipo/ipoRequestAuto";
import { convertDigitToEnglish } from "../../method/convertDigitToEnglish";
import { actionTypes as actionTypesNotif } from "../../../redux/notificationAlert";
import { flagProductionWebSite } from "../../common/apiConfigWebsitPouyan";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100vh',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#050A2A',
        padding: 20,
        overflow: 'auto',
        flexDirection: 'row',
        '@media (max-width:750px)': {
            alignItems: 'flex-start !important',
            '@media (orientation: landscape)': {
                alignItems: 'flex-start',
            },
        }
    },
    grid: {
        width: 700,
        height: 'auto',
        textAlign: 'center',
        maxWidth: '100%',
        '@media (max-width:750px)': {
            width: '100%',
        },
    },
    form: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    textField: {
        width: '100%',
        maxWidth: 327,
        marginBottom: 20,
        '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            backgroundColor: '#FFFFFF',
            '&.Mui-focused': {
                '& fieldset': {
                    borderColor: 'transparent !important',
                },
            },
            '&.Mui-error fieldset': {
                borderColor: 'transparent !important',
            },
        },
        '& .MuiInputBase-input': {
            padding: '15px 14px',
        },
    },
    desc: {
        width: 327,
        margin: 'auto',
        marginTop: 35,
        marginBottom: 35,
        padding: 0,
        fontSize: 16,
        fontWeight: 500,
        color: '#FFFFFF',
        maxWidth: '100%',
    },
    btns: {
        width: 327,
        maxWidth:'99%',
        height: 50,
        backgroundColor: '#050A2A',
        color: '#FFF !important ',
        border: '1px solid #FFF',
        borderRadius: 10,
        marginTop: 20,
        fontWeight: 500,
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,1)',
            color: '#050A2A !important ',
        },
        // '@media (max-width:400px)': {
        //     width: 300,
        // },
        // '@media (max-width:380px)': {
        //     width: 270,
        // }
    },
    gridSocial: {
        width: 100,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 'auto',
        marginTop: 35,
        '& img': {
            cursor: 'pointer'
        },
        '& img:hover': {
            opacity: 0.7,
        }
    },
    modalTitle: {
        color: '#050A2A',
        fontWeight: 'bold',
    },
    modalContent: {
        color: '#050A2A',
    },
    gridTextField: {
        width: 327,
        maxWidth: '100%',
        margin: 'auto',

        '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            backgroundColor: '#FFFFFF',
            '&.Mui-focused': {
                '& fieldset': {
                    borderColor: 'transparent !important',
                },
            },
            '&.Mui-error fieldset': {
                borderColor: 'transparent !important',
            },
        },
        '& .MuiInputBase-input': {
            padding: '15px 14px',
        },
    },
    errorText: {
        color: 'red',
        fontSize: '0.75rem',
        marginTop: '-15px',
        marginBottom: '10px',
    },
    textError: {
        color: '#E60001',
        fontSize: 12,
        fontWeight: 400,
        width: 310,
        maxWidth: '100%',
        textAlign: 'left',

        margin: 'auto',
    },
}));

export default function Index() {

    const classes = useStyles();
    const [openModal, setOpenModal] = useState(false);
    const formikRef = useRef();
    const dispatch = useDispatch();
    let flagProductionWebSiteUser = flagProductionWebSite()

    const initialValues = {
        national_id: '',
        captcha: {
            token: null,
            src: null,
            value: '',
        },
    };

    const validationSchema = Yup.object().shape({
        national_id: Yup.string()
            .matches(/^[0-9]{10}$/, "کد ملی باید ۱۰ رقم باشد")
            .transform(convertPersianToEnglishDigits)
            .test("isValidNationalId", "کد ملی نادرست است!", (value) =>
                value ? validNationalId(value) : false
            )
            .required('کد ملی الزامی است'),
        captcha: Yup.object({
            value: Yup.string().required('مقدار کپچا الزامی است'),
        })
    });

    const handleSubmit = (values, { setSubmitting }) => {
        setSubmitting(false);

        let payload = {
            data: {
                nationalCode: values?.national_id,
            },
            headers: {
                'captcha-value': convertDigitToEnglish(values?.captcha?.value),
                'captcha-token': values?.captcha?.token,
            }
        }

        setSubmitting(true)

        apiCreateUserIPORequest(payload)
            .then((res) => {
                if (res?.status === 200) {
                    formikRef.current.resetForm();
                    dispatch({ type: actionTypesNotif?.success, textAlert: 'درخواست شما با موفقیت ثبت شد' })
                };
            })
            .catch((error) => {
                let result = error?.response

                if (result?.status === 500 && result?.data?.data?.code === 1305) {
                    setOpenModal(true)
                    return
                }

                notificationAlertErrorApi(error, dispatch)
            })
            .finally(() => {
                setSubmitting(false)
                formikRef.current.setFieldValue('captcha.value', '');
                formikRef.current.setTouched({}, false)
                setTimeout(() => {
                    getCaptchMehtod()
                }, 500);
            })
    };

    const getCaptchMehtod = () => {
        getCaptcha()
            .then((res) => {
                if (res?.data?.data?.token && formikRef.current) {
                    formikRef.current.setFieldValue('captcha', {
                        token: res?.data.data.token,
                        src: base64File(res?.data?.data.fileData),
                        value: '',
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching captcha:', error);
            });
    };

    const handleRedirect = () => {
        setOpenModal(false);

        window.open(
            flagProductionWebSiteUser ?'https://reg.pouyanbroker.ir' : 'http://sc-reg.pouyantech.local', '_blank');
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    useEffect(() => {
        getCaptchMehtod();
    }, []);

    return (
        <div className={classes.root}>
            <div className={classes.grid}>
                <div>
                    <img src="/assets/images/logoLinks.png" alt="Pouyan Broker Logo" />
                </div>
                <div>
                    <p className={classes.desc}>
                    «برای شرکت در خرید خودکار عرضه‌های اولیه، ابتدا لازم است در کارگزاری پویان ثبت‌نام نمایید.»
                    </p>
                </div>

                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting, errors, touched, values, setFieldValue }) => (
                        <Form className={classes.form}>
                            <TextField
                                className={classes.textField}
                                variant="outlined"
                                placeholder="کد ملی خود را وارد کنید"
                                name="national_id"
                                value={values.national_id}
                                onChange={(e) => setFieldValue('national_id', e.target.value)}
                                inputProps={{
                                    maxLength: 10,
                                    pattern: "\\d{10}",
                                    inputMode: "numeric"
                                }}
                                error={touched.national_id && Boolean(errors.national_id)}
                                helperText={touched.national_id && errors.national_id}
                            />

                            <div className={classes.gridTextField}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    placeholder="کد امنیتی"
                                    name="captcha.value"
                                    value={values.captcha.value}
                                    onChange={(e) => setFieldValue('captcha.value', e.target.value)}
                                    error={touched.captcha?.value && Boolean(errors.captcha?.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    {values.captcha.src && (
                                                        <img
                                                            src={values.captcha.src}
                                                            alt="captcha"
                                                            style={{ height: 35, marginRight: 10 }}
                                                        />
                                                    )}
                                                    <img
                                                        src="/assets/icons/refresh.svg"
                                                        alt="refresh"
                                                        style={{ cursor: 'pointer', height: 20 }}
                                                        onClick={() => getCaptchMehtod()}
                                                    />
                                                </div>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                {touched.captcha?.value && errors.captcha?.value && (
                                    <div className={classes.errorText}>{errors.captcha.value}</div>
                                )}
                            </div>
                            <ErrorMessage className={classes['textError']} name="captcha.value" component="div" />
                            <Button
                                type="submit"
                                className={classes.btns}
                                variant="contained"
                                disabled={isSubmitting}
                            >
                                خرید خودکار عرضه اولیه
                            </Button>
                        </Form>
                    )}
                </Formik>

                <div className={classes.gridSocial}>
                    <a href="https://t.me/pouyanbroker_official" target="_blank" rel="noopener noreferrer">
                        <img src="/assets/icons/linkes/telegram.svg" alt="Telegram" />
                    </a>
                    <a href="https://www.linkedin.com/company/pouyanbroker" target="_blank" rel="noopener noreferrer">
                        <img src="/assets/icons/linkes/link.svg" alt="LinkedIn" />
                    </a>
                    <a href="https://www.instagram.com/pouyanbrokerage" target="_blank" rel="noopener noreferrer">
                        <img src="/assets/icons/linkes/instal.svg" alt="Instagram" />
                    </a>
                </div>
            </div>

            <Dialog open={openModal} onClose={handleCloseModal}>
                <DialogTitle className={classes.modalTitle}>
                    کاربر گرامی
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className={classes.modalContent}>
                        برای شرکت در خرید عرضه‌های اولیه باید ابتدا در کارگزاری پویان ثبت‌نام کنید.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseModal} color="primary">
                        انصراف
                    </Button>
                    <Button
                        onClick={handleRedirect}
                        color="primary"
                        variant="contained"
                    >
                        ثبت‌نام در کارگزاری
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}